DirectoryTermSuggestions = LP.module 'DirectoryTermSuggestions'

DirectoryTermSuggestions.form = ->
  $('#new_directory_term_suggestion').validate()

  $('#suggest-new-directory-term').on('hidden.bs.modal', ()->
    $('#directory-term-suggestion-messages').html('')
    $('#new_directory_term_suggestion')[0].reset())

  $('#new_directory_term_suggestion').on('ajax:success', (e, messages, $messages) ->
    e.stopPropagation()
    setTimeout(() ->
      $("#suggest-new-directory-term.modal").modal("hide")
    , 500))
